(function() {
  'use strict';

  angular
    .module('admin.wash_trades.service', [])
    .factory('WashTradesService', WashTradesService);

  /** @ngInject */
  function WashTradesService($http, $q, API) {

    function list(start, limit, buyer_id, seller_id, buyer_username, seller_username, username, user_id) {
      var defered = $q.defer();

      $http.get(API.API_URL + 'admin/wash_trade_reports?start=' + start + '&limit=' + limit + '&buyer_id=' + buyer_id + '&seller_id=' + seller_id + '&buyer_username=' + buyer_username + '&seller_username=' + seller_username + '&username=' + username + '&user_id=' + user_id)
        .success(defered.resolve)
        .error(defered.reject);

      return defered.promise;
    }


    function get(id){
      var defered = $q.defer();

      $http.get(API.API_URL + 'admin/wash_trade_reports/' + id)
        .success(defered.resolve)
        .error(defered.reject);

      return defered.promise;
  }

  function save(model){
    var defered = $q.defer();

    $http.post(API.API_URL + 'admin/wash_trade_reports', model)
      .success(defered.resolve)
      .error(defered.reject);

    return defered.promise;
  }

    return{
      list: list,
      get: get,
      save: save,
    };

  }

})();
